import type { TmsContextType } from '@awazevr/mfe-common.contexts.tms'

import { OPTIMIZELY_EVENTS } from '@/constants'
import { OptimizelyState } from '@/context/optimizely-decisions-context'
import { trackClientSideOptimizelyEvent } from '@/utils/optimizely/trackOptimizelyEvent'

// opti_track dataLayer labels (Awaze GTM). These are stable string labels, not
// Optimizely metric event keys (those live in OPTIMIZELY_EVENTS).
export const VIEW_MORE_TRACK_LABEL = 'properties_nearby_view_more'
export const CHANGE_DATES_FLEX_TRACK_LABEL =
  'empty_search_button_dates_and_flexibility'
export const CONTROL_DURATION_TRACK_LABEL = 'empty_search_button_duration'
export const CONTROL_FLEXIBILITY_TRACK_LABEL = 'empty_search_button_flexibility'

// Shared Awaze opti_track dataLayer event. tms is undefined without a provider.
const pushOptiTrack = (
  tms: TmsContextType | undefined,
  trackAction: 'click' | 'impression',
  trackLabel: string,
): void => {
  tms?.updateDataLayer?.('link', 'opti_track', {
    track_action: trackAction,
    track_label: trackLabel,
  })
}

export const trackPropertiesNearbySeen = (
  optimizelyState: OptimizelyState,
  _tms?: TmsContextType | undefined,
): void => {
  // The impression is measured via the Optimizely metric event only; there is
  // no opti_track dataLayer label for the carousel impression.
  void trackClientSideOptimizelyEvent(
    OPTIMIZELY_EVENTS.PROPERTIES_NEARBY_SEEN,
    optimizelyState,
  )
}

export const trackPropertiesNearbyCardClick = (
  optimizelyState: OptimizelyState,
): void => {
  void trackClientSideOptimizelyEvent(
    OPTIMIZELY_EVENTS.PROPERTIES_NEARBY_CARD_CLICK,
    optimizelyState,
  )
}

export const trackViewMoreClick = (tms: TmsContextType | undefined): void => {
  pushOptiTrack(tms, 'click', VIEW_MORE_TRACK_LABEL)
}

export const trackLowResultsSeen = (optimizelyState: OptimizelyState): void => {
  void trackClientSideOptimizelyEvent(
    OPTIMIZELY_EVENTS.LOW_RESULTS_SEEN,
    optimizelyState,
  )
}

export const trackChangeDatesFlexClick = (
  tms: TmsContextType | undefined,
): void => {
  pushOptiTrack(tms, 'click', CHANGE_DATES_FLEX_TRACK_LABEL)
}

export const trackControlDurationClick = (
  tms: TmsContextType | undefined,
): void => {
  pushOptiTrack(tms, 'click', CONTROL_DURATION_TRACK_LABEL)
}

export const trackControlFlexibilityClick = (
  tms: TmsContextType | undefined,
): void => {
  pushOptiTrack(tms, 'click', CONTROL_FLEXIBILITY_TRACK_LABEL)
}
